import React, { useEffect, useRef, useState } from "react";
import { LOGIN_LOGO_URL } from "constants/brand";
import {
  getLoginLogoPreloadStatus,
  preloadLoginLogo,
} from "utils/preloadLoginLogo";
import "./animatedLogo.scss";

const AnimatedLogo = ({ src = LOGIN_LOGO_URL, alt = "logo", className = "" }) => {
  const alreadyCached = getLoginLogoPreloadStatus();
  const [status, setStatus] = useState(alreadyCached ? "loaded" : "loading");
  const [instant, setInstant] = useState(alreadyCached);
  const imgRef = useRef(null);

  const markLoaded = (isCached = false) => {
    if (isCached) setInstant(true);
    setStatus("loaded");
  };

  useEffect(() => {
    let cancelled = false;

    preloadLoginLogo()
      .then(() => {
        if (!cancelled) markLoaded(true);
      })
      .catch(() => {});

    const img = imgRef.current;
    if (img?.complete && img.naturalHeight > 0) {
      markLoaded(true);
    }

    return () => {
      cancelled = true;
    };
  }, [src]);

  return (
    <div
      className={`animated-logo animated-logo--${status}${instant ? " animated-logo--instant" : ""} ${className}`.trim()}
    >
      {!instant && (
        <div className="animated-logo__loader" aria-hidden="true">
          <span className="animated-logo__ring" />
          <span className="animated-logo__shimmer" />
        </div>
      )}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className="animated-logo__img"
        fetchPriority="high"
        loading="eager"
        decoding="async"
        onLoad={() => markLoaded(getLoginLogoPreloadStatus())}
        onError={() => setStatus("error")}
      />
    </div>
  );
};

export default AnimatedLogo;
